import React, { useState } from "react";
const CustomDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select an option");
  const options = ["Option 1", "Option 2", "Option 3"];
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };
  return (
    <div style={{ position: "relative", width: "200px" }}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          border: "1px solid #ccc",
          padding: "10px",
          backgroundColor: "white",
          cursor: "pointer",
        }}
      >
        {selectedOption}
      </div>
      {isOpen && (
        <ul
          style={{
            listStyle: "none",
            margin: 0,
            padding: 0,
            border: "1px solid #ccc",
            position: "absolute",
            width: "100%",
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          {options.map((option, index) => (
            <li
              key={index}
              onClick={() => handleOptionClick(option)}
              style={{
                padding: "10px",
                backgroundColor: option === selectedOption ? "lightblue" : "white",
                cursor: "pointer",
              }}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
export default CustomDropdown;